const rotateArray = <T>(source: Array<T>, multipleRotation = 1) => {
    for (let rotation = 0; rotation < multipleRotation; rotation++) {
        source.unshift(source.pop() as T);
    }

    return source;
};

export default rotateArray;
